/**
 * Job listing constants for use in the Job Listing component
 * /src/components/CardContainer/Listing/Jobs
 */

// Set of top level Job categories
const JOB_TERM_COUNTRIES = "By Country";
const JOB_TERM_DEPARTMENTS = "By Department";

const JOB_TERM_COUNTRIES_ID = "country";
const JOB_TERM_DEPARTMENTS_ID = "category";

const jobCategoryFieldMapping = {
    [JOB_TERM_COUNTRIES]: JOB_TERM_COUNTRIES_ID,
    [JOB_TERM_DEPARTMENTS]: JOB_TERM_DEPARTMENTS_ID,
};

const JOB_RESET_FILTERS_TEXT = "job.clear-filters";
const JOB_RESET_ALL_FILTERS = "job.clear-all-filters";
const JOB_NO_RESULTS_TEXT = "job.no-results-text";
const JOB_PRELOADER_TEXT = "job.pre-loader-text";
const JOB_PAGE_SIZE = 9;

/**
 * Exported constants.
 */
export {
    JOB_TERM_COUNTRIES,
    JOB_TERM_DEPARTMENTS,
    JOB_TERM_COUNTRIES_ID,
    JOB_TERM_DEPARTMENTS_ID,
    jobCategoryFieldMapping,
    JOB_RESET_FILTERS_TEXT,
    JOB_RESET_ALL_FILTERS,
    JOB_PAGE_SIZE,
    JOB_NO_RESULTS_TEXT,
    JOB_PRELOADER_TEXT,
};
